import { useIoContext } from '~/contexts';
export function useIsNativeAppleSignIn() {
    const { native } = useIoContext();
    return native.platform === 'ios';
}
export function useIsAppleSignInVisible() {
    const { native } = useIoContext();
    return native.platform === 'ios' || native.platform === 'web';
}
